var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCancel = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 34 34",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M17 .333C7.784.333.333 7.783.333 17c0 9.217 7.45 16.667 16.667 16.667 9.217 0 16.667-7.45 16.667-16.667C33.667 7.783 26.217.333 17 .333Zm8.334 22.65-2.35 2.35L17 19.35l-5.983 5.983-2.35-2.35L14.65 17l-5.983-5.983 2.35-2.35L17 14.65l5.983-5.983 2.35 2.35L19.35 17l5.983 5.983Z"
})));
export default SvgCancel;